import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue, reduxForm } from 'redux-form';
import {
  PERFIL_ADMIN, getAdminEmpresa, getGestorEmpresa
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import DetalheConfiguracaoBilhete from './DetalheConfiguracaoBilhete';
import alterarExibicaoDetalhamentoConfiguracaoBilhete from '../../actions/configuracao-bilhete/alterarExibicaoDetalhamentoConfiguracaoBilhete';

export class ConfiguracaoBilhete extends React.Component {
    constructor (props) {
      super(props)
      this.state = {
        configuracaoSelecionada: null,
      };
    }

    exibirIcone () {      
      if (this.props.configuracao.exibirDetalhe) {
          return <i className="material-icons" style={{ cursor: 'pointer' }} onClick={() => this.props.alterarExibicaoDetalhamentoConfiguracaoBilhete(this.props.configuracao)}>
          &#xE5C7;</i>
      }
      return <i className="material-icons" style={{ cursor: 'pointer' }} onClick={() => this.props.alterarExibicaoDetalhamentoConfiguracaoBilhete(this.props.configuracao)}>&#xE5C5;</i>
    }

    selecionar(configuracao) {      
      if (configuracao.nomeCidade !== null) {        
          const cidadeDeOrigem = {
            id: configuracao.codigoCidade,
            nome: configuracao.nomeCidade,
            uf: configuracao.uf
          };
        this.props.selecionarOrigem(cidadeDeOrigem);
      }

      this.props.selecionarBilhete(configuracao)
    }

    render () {
        return (
          <div className="vx-gp-row">
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
              getGestorEmpresa(this.props.empresaSelecionada.id),
              getAdminEmpresa(this.props.empresaSelecionada.id)]}>
              <div className="vx-gp-row-main vx-gp-row-main--bilhete"
                   style={{ cursor: 'pointer' }}
                   onClick={() => this.props.alterarExibicaoDetalhamentoConfiguracaoBilhete(this.props.configuracao)}>
                <div className="vx-gp-field" style={{ alignItems: 'center' }}>
                  {this.exibirIcone()}
                </div>
                <div className="vx-gp-field">
                  <span className="vx-gp-field-label">Cidade</span>
                  <span className="vx-gp-field-value">
                    {this.props.configuracao.cidade ? this.props.configuracao.cidade.nomeComUf : '-'}
                  </span>
                </div>
                <div className="vx-gp-field">
                  <span className="vx-gp-field-label">Regra</span>
                  <span className="vx-gp-field-value">{this.props.configuracao.regra.valor}</span>
                </div>
              </div>
              {this.props.configuracao.exibirDetalhe &&
                <DetalheConfiguracaoBilhete configuracao={this.props.configuracao} selecionarBilhete={this.selecionar.bind(this)} />
              }
            </Autorizacao>
          </div>
        )
      }
}

export function mapStateToProps (state) {
    return {
      empresaSelecionada: state.empresaSelecionada
    }
  }

export default connect(mapStateToProps, {
  changeFieldValue,      
  selecionarOrigem,
  alterarExibicaoDetalhamentoConfiguracaoBilhete
})(reduxForm({
    form: 'formCadastrarConfiguracaoBilhete'
  })(ConfiguracaoBilhete))
